import { Component, Prop, Ref, Vue, Watch, Inject } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Loading from "@/components/loading/loading.vue";
import { Form, Input, Select, Icon } from "ant-design-vue";
import { ActionItem, Action } from "commonui";
import { AnnotationTypes } from "../objects/annotation-type";
import * as d3 from "d3";
import { toNumber } from "lodash";
import AnnotationState from "@/modules/annotation";
@Component({
	components: {
		Search: Input.Search,
		Select,
		Option: Select.Option,
		Form,
		FormItem: Form.Item,
		Loading,
		Action,
		ActionItem,
		Icon
	}
})
export default class ToolBox extends Vue {
	@Prop({ default: false }) selectorOpen!: boolean;
	@Prop({ default: "" }) toolSelected!: string;

	@Inject("cloneShapeFunc") readonly cloneShapeFunc!: () => void;
	@Inject("removeShapeFunc") readonly removeShapeFunc!: () => void;

	public colorOptions = ["black", "red", "orange", "yellow", "green", "blue", "purple", "white"];
	public showColorsPopover: boolean = false;
	public color: string = this.colorOptions[0];
	private annotationStore = getModule(AnnotationState);
	public shapeDragging: AnnotationTypes | null = null;
	mounted() {
		this.setDragBehaviour();
		window.addEventListener("mousedown", this.clearBucketSelected);
	}

	beforeDestroy() {
		window.removeEventListener("mousedown", this.clearBucketSelected);
	}

	clearBucketSelected() {
		if (this.annotationStore.isFillingColor) {
			this.annotationStore.toggleFillColor();
		}
	}

	@Watch("color", { immediate: true })
	changeColor(currentColor) {
		this.annotationStore.changeColor(currentColor);
	}

	public get AnnotationTypes() {
		return AnnotationTypes;
	}

	public onColorToolClick() {
		this.showColorsPopover = !this.showColorsPopover;
	}
	public onOutsideClick() {
		this.showColorsPopover = false;
	}

	public onColorSelect(color: string) {
		this.color = color;
		this.onColorToolClick();
	}

	public dropAnnotation(type: AnnotationTypes, screenX: number, screenY: number) {
		this.$emit("dropAnnotation", { type, x: screenX, y: screenY, color: this.color });
	}

	private setDragBehaviour() {
		const self = this;
		let node: d3.Selection<SVGGElement, unknown, null, undefined> | null = null;
		let type: AnnotationTypes;
		const start = function (this: SVGGElement, event: d3.D3DragEvent<SVGGElement, any, any>) {
			self.clearBucketSelected();
			node = d3.select(this).clone(true).classed("dragging", true).style("display", "none");
			type = toNumber(this.parentElement?.getAttribute("data-annotation"));
			self.shapeDragging = type;
		};
		const drag = function (this: SVGGElement, event: d3.D3DragEvent<SVGGElement, any, any>) {
			const halfOfWidth = this.clientWidth / 2;
			const halfOfHeight = this.clientHeight / 2;
			const left = event.sourceEvent.x - halfOfWidth;
			const top = event.sourceEvent.y - halfOfHeight;
			node?.raise().attr(
				"style",
				`pointer-events: none;display: block; position: fixed; z-index: 9; left: ${left}px; top: ${top}px`
			);
		};
		const end = function (this: SVGGElement, event: any) {
			node?.classed("dragging", false).remove();
			node = null;
			self.dropAnnotation(type, event.sourceEvent.x, event.sourceEvent.y);
			self.shapeDragging = null;
		};
		const dragBehaviour = d3
			.drag()
			.on("start", start as any)
			.on("drag", drag as any)
			.on("end", end as any);
		d3.selectAll("[data-annotation] > svg").call(dragBehaviour as any);
	}

	public onFillColor() {
		this.annotationStore.toggleFillColor();
	}

	public onDuplicateShape() {
		this.cloneShapeFunc();
	}

	public onRemoveShape() {
		this.removeShapeFunc();
	}
}
